import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { getAttribution, googleAuthUrl } from '../lib/attribution';

export default function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [heardFrom, setHeardFrom] = useState('');
  const navigate = useNavigate();

  const API_URL = process.env.REACT_APP_API_URL;
  if (!API_URL) throw new Error("REACT_APP_API_URL is not defined");

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    try {
      console.log("Sending registration request..."); // Debug
      await api.post('/api/auth/register', { email, password, confirmPassword, heardFrom, attribution: getAttribution() });
      console.log("Registration successful — navigating...");
      navigate("/verify-email-sent");
    } catch (err: any) {
      console.error("Registration failed:", err);
      setError(err.response?.data?.message || "Registration failed — please try again");
    }
  };

  const handleGoogleLogin = () => {
    window.location.href = googleAuthUrl(API_URL, heardFrom);
  };

  return (
    <div className="page-shell flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-extrabold text-secondary mb-2">Create your account</h1>
          <p className="text-textMuted">Start removing AI detection today</p>
        </div>
        <div className="ui-card p-8">
                    <select
            value={heardFrom}
            onChange={e => setHeardFrom(e.target.value)}
            className="ui-input mb-6"
          >
            <option value="">How did you hear about us? (optional)</option>
            <option value="tiktok">TikTok</option>
            <option value="instagram">Instagram</option>
            <option value="youtube">YouTube</option>
            <option value="google">Google</option>
            <option value="friend">Friend</option>
            <option value="other">Other</option>
          </select>
          <button
            onClick={handleGoogleLogin}
            className="btn-secondary mb-6 w-full border-2 py-3"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Sign up with Google
          </button>
          <div className="relative mb-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-slate-300"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="bg-white px-4 text-textMuted">or</span>
            </div>
          </div>
          <form onSubmit={handleRegister} className="space-y-5">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              className="ui-input"
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              className="ui-input"
            />
            <input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              required
              className="ui-input"
            />
            {error && <p className="text-red-600 text-sm text-center font-medium">{error}</p>}
            <button
              type="submit"
              className="btn-primary w-full py-4 text-lg"
            >
              Create Account
            </button>
          </form>
          <p className="mt-8 text-center text-textMuted">
            Already have an account?{" "}
            <a href="/login" className="text-primary font-semibold hover:underline">
              Log in
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}